import { message, Modal } from "antd";
import Big from "big.js";
import alert from "components/elements/Alert";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import useOptions from "features/masterData/hooks/useOptions";
import _, { get } from "lodash";
import { deleteKeysByList } from "utils/helper";

import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import * as services from "../../masterData/services/optionsApi";
import * as service from "../services/salaryApi";
import {
  setCommonTypeByGroupType,
  setCommonTypeCompany,
  setEmploymentTypeOptions,
  setIsLoading,
  setMovementByTypePayment,
  setPayrollPeriodByEmployee,
  setPayrollPeriodYear,
  setSalaryDecryptInformation
} from "../slices/salarySlice";

const getChangedFields = (newValues, oldValues) => {
  return Object.keys(newValues).reduce((acc, key) => {
    if (!_.isEqual(newValues[key], oldValues[key])) {
      acc[key] = newValues[key];
    }
    return acc;
  }, {});
};

function useEmployeeSalarySalary() {
  const { movementGroupOptions = [], getMovementGroupOptions } = useOptions();
  const { t } = useTranslation();
  const { id } = useParams();
  const DELETE_KEYS_LIST = ["current", "pageSize", "pagination"];
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.salary.isLoading);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const currentSalary = useSelector((state) => state.salary.salaryDecryptInformation);
  const employmentTypeOptions = useSelector((state) => state.salary.employmentTypeOptions);
  const movementByTypePayment = useSelector((state) => state.salary.movementByTypePayment);
  const bankGroupType = useSelector((state) => state.salary.commonTypeCompany);
  const payrollPeriodByEmployee = useSelector((state) => state.salary.payrollPeriodByEmployee);
  const payrollPeriodYear = useSelector((state) => state.salary.payrollPeriodYear);
  const [isMovement, setMovement] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [isMount, setIsMount] = useState(true);
  const [sorter, setSorter] = useState([]);

  const [isModalDownloadOpen, setIsModalDownloadOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear() + "");
  const [selectedMonth, setSelectedMonth] = useState(null);

  const [isDownloading, setIsDownloading] = useState({});

  const showModal = () => {
    setIsModalDownloadOpen(true);
  };
  const handleOk = () => {
    setIsModalDownloadOpen(false);
  };
  const handleCancel = () => {
    setIsModalDownloadOpen(false);
  };
  const onEdit = () => {
    setIsEditing(true)
    setIsVisible(true)
  };
  const handleToggleVisibility = () => {
    setIsVisible(prev => !prev);
    setIsEditing(false)
  };

  useEffect(() => {
    if (isVisible !== undefined) {
      getMovementByTypePayment(pagination, isVisible, isEditing);
      getSalaryDecryptInformation(isVisible, isEditing);
    }
  }, [isVisible]);

  useEffect(() => {
    if (isEditing !== undefined) {
      getMovementByTypePayment(pagination, isVisible, isEditing);
      getSalaryDecryptInformation(isVisible, isEditing);
    }
  }, [isEditing]);

  const getCommonType = useCallback(async () => {
    dispatch(setIsLoading(true));
    try {
      const response = await service.getCommonTypeByGroupType({
        companyId: currentCompany,
        groupType: "EMPLOYMENT_TYPE",
      });
      dispatch(setCommonTypeByGroupType(response?.data));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);


  function toParams(values = {}) {
    const { pagination = {}, sortBy = [] } = values;
    const modifiedParams = {
      ...values,

      page: pagination.page || 0,
      size: pagination.pageSize || 10,
      sortBy: sortBy
        .filter((s) => s.order !== undefined)
        .map((s) => ({
          direction: s.order === "descend" ? "desc" : "asc",
          property: s.field,
        })),
    };
    const deletedKeys = deleteKeysByList(modifiedParams, DELETE_KEYS_LIST);
    return deletedKeys;
  }




  const getPayrollPeriodByEmployeeData = useCallback(async () => {
    dispatch(setIsLoading(true));
    try {
      const response = await service.getPayrollPeriodByEmployee({
        year: selectedYear,
        companyId: currentCompany,
        employeeId: currentEmployee,
        actionId: currentEmployee
      });
      dispatch(setPayrollPeriodByEmployee(response?.data?.content));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch, selectedYear]);

  const monthList = useMemo(() => {
    // console.log("payrollPeriodByEmployee", payrollPeriodByEmployee);
    let set = new Set()
    Array.from(payrollPeriodByEmployee)?.forEach(o => {
      set.add({
        value: o.month,
        label: dayjs(o.startPeriod).format("MMMM")
      })
    });
    // console.log("set ", Array.from(set))

    return Array.from(set);
  }, [payrollPeriodByEmployee]);

  // console.log("monthList", monthList);

  const filteredPayrollPeriod = useMemo(() => {
    if (!selectedMonth) return payrollPeriodByEmployee;
    return payrollPeriodByEmployee.filter(
      (data) => data.month === selectedMonth
    );
  }, [selectedMonth, payrollPeriodByEmployee]);

  const getPaySlipReportByPayrollPeriodFile = useCallback(async (params) => {
    const id = params?.id;
    setIsDownloading(prev => ({ ...prev, [id]: true }));
    dispatch(setIsLoading(true));

    // console.log("data getslip", params);
    try {
      const response = await service.getPaySlipReportByPayrollPeriod({
        payrollPeriodId: params?.id,
        year: selectedYear,
        companyId: currentCompany,
        employeeId: currentEmployee,
        actionId: currentEmployee
      });

      const url = window.URL.createObjectURL(response?.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "payslip.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      // dispatch(setPayrollPeriodByEmployee(response?.data?.content));
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloading(prev => ({ ...prev, [id]: false }));
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const getBankGroupType = useCallback(async () => {
    dispatch(setIsLoading(true));
    try {
      const response = await service.getBankOption({
        companyId: currentCompany,
        employeeId: currentEmployee,
        actionId: currentEmployee
      });
      dispatch(setCommonTypeCompany(response?.data));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const getEmploymentAllOptions = useCallback(async () => {
    dispatch(setIsLoading(true));
    try {
      const response = await services.getEmploymentAllOptions({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: id,
        actionId: generateRandomString(),
      });
      const modifiedValues = response?.data?.employmentTypeSetupList.map((item) => ({
        id: item.id,
        name: item.employmentTypeName,
        nameEn: item.employmentTypeNameEn,
      }));
      dispatch(setEmploymentTypeOptions(modifiedValues));
    } catch (error) {
      alert({
        type: "error",
        resultObject: error,
        message: "Get employment options failed!!!",
      });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch, id]);

  const getMovementByTypePayment = useCallback(async (params = {}, visible = false, edit = false) => {
    dispatch(setIsLoading(true));
    try {

      pagination.page = params?.page || 0;
      pagination.size = params?.size || 10;

      const response = await service.getMovementByTypePayment({
        ...params,
        companyId: currentCompany,
        requestId: generateRandomString(),
        employeeId: id ? id : currentEmployee,
        actionId: id ? id : currentEmployee,
        visible: visible,
        isEdit: edit
      });

      // setPagination({
      //   ...pagination,
      //   // ...params?.request,
      //   current: response?.data?.content.pageNo + 1,
      //   pageNo: response?.data?.content.totalPages + 1,
      //   // ...modifiedParams.pagination,
      //   total: response.data?.totalItems,
      // });
      console.log("pagination", pagination);

      setPagination({
        ...pagination,
        page: response?.data?.content.pageNo + 1,
        size: response?.data?.content.totalPages + 1,
        range: [
          params.page * params.size + 1,
          Math.min((params.page + 1) * params.size, response.data?.totalItems),
        ],
        total: response.data?.totalItems,
      });

      console.log("response", response?.data?.content);
      const modifiedValues = response.data?.content.map(item => ({
        ...item,
        oldData: item?.oldData,
        newData: item?.newData
      }));
      console.log("modifiedValues", modifiedValues);
      dispatch(setMovementByTypePayment(modifiedValues));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch, id, movementGroupOptions, pagination, isLoading]);

  const onChange = useCallback(
    (tablePagination, _, tableSorter) => {
      setPagination(tablePagination);
      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];
      setSorter(modifiedSorter);
      const modifiedParams = toParams({
        pagination: {
          page: tablePagination.current - 1,
          pageSize: tablePagination.pageSize,
        },
        sortBy: modifiedSorter,
      });
      setPagination({ ...modifiedParams?.pagination });

      // TODO: If sorting or filtering has changed, Change page to 0
      getMovementByTypePayment(modifiedParams, isVisible, isEditing);
    },
    [getMovementByTypePayment]
  );


  const getSalaryDecryptInformation = useCallback(async (visible = false, edit = false) => {
    // dispatch(setIsLoading(true));
    try {
      const response = await service.getSalaryDecryptInformation({
        companyId: currentCompany,
        requestId: generateRandomString(),
        employeeId: id,
        actionId: currentEmployee,
        visible: visible,
        isEdit: edit
      });

      const modifiedValues = {
        ...response?.data?.financial,
        bankAccountId: response?.data?.financial?.bankAccount?.id,
        employmentTypeId: response?.data?.financial?.employmentType?.id,
        // salary: response?.data?.financial?.salary ? get2DecimalPointsWithCommas(response?.data?.financial?.salary) : 'x,xxx.xx',
        salary: (response?.data?.financial?.salary && Number(response?.data?.financial?.salary) > 0)
          ? get2DecimalPointsWithCommas(response?.data?.financial?.salary)
          : edit ? "0.00" : response?.data?.financial?.salary,
        visible: response?.data?.visible,
        importSpecialPeriod: response?.data?.importSpecialPeriod === "Y"
      };
      console.log("response?.data?.importSpecialPeriod? true:false ", modifiedValues);

      dispatch(setSalaryDecryptInformation(modifiedValues));
    } catch (error) {
      console.error(error);
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch, id]);


  const createMovement = useCallback(async (values) => {
    dispatch(setIsLoading(true));
    try {
      await service.createMovement({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
        sendingType: "SUBMIT",
        ...values,
        effectiveDate: values?.effectiveDate,
        movementTypeList: [values?.movementTypeListId],
        //set data
        importSpecialPeriod: values?.importSpecialPeriod ? "Y" : "N",
        bankAccountNo: values?.oldValue.bankAccountNo,
        newValue: { ...values?.newValue, bankAccountNo: values?.oldValue?.bankAccountNo },
        newDataShow: { ...values?.newDataShow, bankAccountNo: values?.oldDataShow?.bankAccountNo }
      });
      await getMovementByTypePayment();
      message.success(t("common.success"))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch, getMovementByTypePayment, id]);

  const updateSalaryInformation = useCallback(async (values) => {
    dispatch(setIsLoading(true));
    try {
      const sanitizedSalary = values.salary.replace(/,/g, ""); // ลบเครื่องหมาย ',' ออกจาก salary
      console.log("values", values);
      const request = {
        ...values,
        salary: new Big(sanitizedSalary),
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
        //set data
        effectiveDate: dayjs(),
        importSpecialPeriod: values?.importSpecialPeriod ? "Y" : "N",
        bankAccountNo: values?.oldValue.bankAccountNo,
        newValue: { ...values?.newValue, bankAccountNo: values?.oldValue?.bankAccountNo },
        newDataShow: { ...values?.newDataShow, bankAccountNo: values?.oldDataShow?.bankAccountNo }
      };
      await service.updateSalaryInformation(request);
      await getMovementByTypePayment(pagination, isVisible, isEditing);
      await getSalaryDecryptInformation();
      message.success(t("common.success"))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, currentCompany, id, currentEmployee, getMovementByTypePayment, getSalaryDecryptInformation]);

  const updateMovement = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true));
      setModalOpen(false);
      const request = {
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
        movementId: values.id,
        remark: values.remark,
        effectiveDate: values.effectiveDate,
      };
      await service.updateMovement(request);
      await getMovementByTypePayment();
      message.success(t("common.success"))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, currentCompany, id, currentEmployee, getMovementByTypePayment]);

  const deleteMovement = useCallback(async (values) => {
    dispatch(setIsLoading(true));
    try {
      const request = {
        movementId: values,
        companyId: currentCompany,
        employeeId: id,
        actionId: currentEmployee,
      };
      await service.deleteMovement(request);
      await getMovementByTypePayment();
      message.success(t("common.success"))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, currentCompany, id, currentEmployee, getMovementByTypePayment]);

  const onSubmit = useCallback(async (values, { resetFields, setFieldsValue }, setEdit) => {
    try {
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: <p>{t("dialog.confirmation.create").replace("{entity}", t("employee.salary.header"))}</p>,
        onOk() {
          console.log("values", values);
          const sanitizedSalary = values?.salary?.replace?.(/,/g, "") ?? values?.salary; // ลบเครื่องหมาย ',' ออกจาก salary
          const sanitizedSalary2 = currentSalary?.salary?.replace?.(/,/g, "") ?? 0; // ลบเครื่องหมาย ',' ออกจาก salary
          if (_.isEqual(new Big(sanitizedSalary), new Big(sanitizedSalary2))) {
            const changedOldFields = getChangedFields(currentSalary, values);
            const changedNewFields = getChangedFields(values, currentSalary);

            let bankAccountOld = null;
            let bankAccountNew = null;
            let employmentTypeOld = null;
            let employmentTypeNew = null;

            if (!_.isEqual(values.bankAccountId, currentSalary.bankAccountId)) {
              bankAccountOld = bankGroupType.find(item => item.id === currentSalary.bankAccountId);
              bankAccountNew = bankGroupType.find(item => item.id === values.bankAccountId);
            }

            if (!_.isEqual(values.employmentTypeId, currentSalary.employmentTypeId)) {
              employmentTypeOld = employmentTypeOptions.find(item => item.id === currentSalary.employmentTypeId);
              employmentTypeNew = employmentTypeOptions.find(item => item.id === values.employmentTypeId);
            }
            updateSalaryInformation({
              ...values, ...{
                oldValue: {
                  ...currentSalary,
                  bankAccount: bankAccountOld,
                  employmentType: employmentTypeOld,
                },
                newValue: {
                  ...values,
                  bankAccount: bankAccountNew,
                  employmentType: employmentTypeNew,
                  salary: get2DecimalPointsWithCommas(values.salary),
                },
                oldDataShow: {
                  ...changedOldFields,
                  bankAccount: bankAccountOld,
                  employmentType: employmentTypeOld,
                },
                newDataShow: {
                  ...changedNewFields,
                  bankAccount: bankAccountNew,
                  employmentType: employmentTypeNew,
                  salary: get2DecimalPointsWithCommas(values.salary),
                }
              }
            });
            if (setEdit)
              setEdit(false)
          } else {
            const changedOldFields = getChangedFields(currentSalary, values);
            const changedNewFields = getChangedFields(values, currentSalary);

            let bankAccountOld = null;
            let bankAccountNew = null;
            let employmentTypeOld = null;
            let employmentTypeNew = null;

            if (!_.isEqual(values.bankAccountId, currentSalary.bankAccountId)) {
              bankAccountOld = bankGroupType.find(item => item.id === currentSalary.bankAccountId);
              bankAccountNew = bankGroupType.find(item => item.id === values.bankAccountId);
            }

            if (!_.isEqual(values.employmentTypeId, currentSalary.employmentTypeId)) {
              employmentTypeOld = employmentTypeOptions.find(item => item.id === currentSalary.employmentTypeId);
              employmentTypeNew = employmentTypeOptions.find(item => item.id === values.employmentTypeId);
            }

            // console.log(values.salary)
            // console.log(get2DecimalPointsWithCommas(values.salary))

            setMovement({
              oldValue: {
                ...currentSalary,
                bankAccount: bankAccountOld,
                employmentType: employmentTypeOld,
              },
              newValue: {
                ...values,
                bankAccount: bankAccountNew,
                employmentType: employmentTypeNew,
                salary: get2DecimalPointsWithCommas(values.salary),
              },
              oldDataShow: {
                ...changedOldFields,
                bankAccount: bankAccountOld,
                employmentType: employmentTypeOld,
              },
              newDataShow: {
                ...changedNewFields,
                bankAccount: bankAccountNew,
                employmentType: employmentTypeNew,
                salary: get2DecimalPointsWithCommas(values.salary),
              }
            });
            setModalOpen(true);
            resetFields();
            console.log("setEdit", setEdit);

          }
        },
        onCancel() { },
        okText: t("common.confirm"),
        cancelText: t("common.cancel"),
      });
    } catch (error) {
      console.error(error);
    }
  }, [bankGroupType, currentSalary, employmentTypeOptions, t, updateSalaryInformation]);

  const onSubmitModal = useCallback(async (values) => {
    dispatch(setIsLoading(true));
    try {
      if (values?.forceSave === true) {
        await updateSalaryInformation({ ...values, ...values.newValue });
      } else if (values?.id) {
        await updateMovement(values);
      } else {
        await createMovement(values);
      }
      onCancel();
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, updateSalaryInformation, updateMovement, createMovement]);

  const onCancel = useCallback(() => {
    setIsLoading(false);
    setIsVisible(false);
    setIsEditing(false);
    setIsMount(true);
    setModalOpen(false);
  }, []);

  const onRowClick = useCallback(async (values) => {
    setMovement({
      ...values,
      effectiveDate: values.effectiveDate,
      oldDataShow: { ...values?.oldData, bankAccountId: values?.oldData?.bankAccount?.id, employmentTypeId: values?.oldData?.employmentType?.id },
      newDataShow: { ...values?.newData, bankAccountId: values?.newData?.bankAccount?.id, employmentTypeId: values?.newData?.employmentType?.id }
    });
    setModalOpen(true);
  }, []);

  const onRowDelete = useCallback(async (values) => {
    try {
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: <p>{t("dialog.confirmation.delete").replace("{entity}", t("movement.header"))}</p>,
        onOk() {
          deleteMovement(values);
        },
        onCancel() { },
        okText: t("common.confirm"),
        cancelText: t("common.cancel"),
      });
    } catch (error) {
      console.error(error);
    }
  }, [deleteMovement, t]);

  const getPayrollPeriodYearOptions = useCallback(async () => {
    // dispatch(setIsLoading(true));
    try {
      const response = await service.getPayrollPeriodYear({
        year: new Date().getFullYear(),
        employeeId: currentEmployee,
        companyId: currentCompany,
        actionId: generateRandomString(),
      });
      // console.log("response?.data", response?.data?.content?.year?.map((item) => ({
      //   value: item,
      //   label: item
      // })));

      const modifiedValues = response?.data?.content?.year?.map((item) => ({
        value: item,
        label: item
      }));

      const defaultYear = modifiedValues[modifiedValues?.length - 1]?.value;

      setSelectedYear(defaultYear);

      dispatch(setPayrollPeriodYear(modifiedValues));
    } catch (error) {
      alert({
        type: "error",
        resultObject: error,
        message: "Get payroll period year options failed!!!",
      });
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch, id]);



  useEffect(() => {
    if (currentCompany) {
      getMovementGroupOptions({
        companyId: currentCompany,
        employeeId: id,
      });
    }
  }, [currentCompany, getMovementGroupOptions, id]);

  useEffect(() => {
    if (isModalDownloadOpen) {
      getPayrollPeriodYearOptions();
    }
  }, [isModalDownloadOpen, getPayrollPeriodYearOptions]);

  useEffect(() => {
    if (isModalDownloadOpen && selectedYear) {
      getPayrollPeriodByEmployeeData();
    }
  }, [isModalDownloadOpen, selectedYear, getPayrollPeriodByEmployeeData]);

  useEffect(() => {
    if (currentCompany && isMount) {
      getEmploymentAllOptions();
      getCommonType();
      getBankGroupType();
      getMovementByTypePayment(pagination, isVisible, isEditing);
      getSalaryDecryptInformation();
      // getPayrollPeriodByEmployeeData();
      setIsMount(false)
    }
  }, [currentCompany, getEmploymentAllOptions, getCommonType, getBankGroupType, getMovementByTypePayment, getSalaryDecryptInformation]);

  return {
    isLoading,
    movementByTypePayment,
    movementGroupOptions,
    employmentTypeOptions,
    payrollPeriodByEmployee,
    payrollPeriodYear,
    currentSalary,
    bankGroupType,
    isModalOpen,
    isModalDownloadOpen,
    isMovement,
    isVisible,
    setIsVisible,
    setIsModalDownloadOpen,
    onSubmit,
    onSubmitModal,
    onCancel,
    onRowClick,
    onRowDelete,
    pagination,
    showModal,
    handleOk,
    handleCancel,
    monthList,
    filteredPayrollPeriod,
    setSelectedMonth,
    getPaySlipReportByPayrollPeriodFile,
    selectedYear,
    setSelectedYear,
    onChange,
    onEdit,
    handleToggleVisibility,
    isDownloading
  };
}

export default useEmployeeSalarySalary;
